import { Order } from "../models/order";
import { TaskType } from "./enums";

export const isEnableBOL = (order?: Order) => {
  if (order && order?.tasks && order?.tasks?.length > 0) {
    const task = order?.tasks?.find((task) => task?.type !== TaskType.PACK);

    if (task) return true;
  }

  return false;
};
